import Styled, { createGlobalStyle } from "styled-components";

import button from "./_styles/buttons.js";
import components from "./_styles/components.js";
import fonts from "./_styles/fonts.js";
import colors from "./_styles/colors.js";
import reset from "./_styles/reset.js";

import { getWhitelabelFontConfig } from "./whitelabel/fonts/registry";

const getButtonBorderRadius = (borderRadius) => {
  if (borderRadius == null || borderRadius === "") return "4px";
  if (typeof borderRadius === "number") return `${borderRadius}px`;
  const value = String(borderRadius).trim();
  if (/^\d+(\.\d+)?$/.test(value)) return `${value}px`;
  return value;
};

const GlobalStyles = createGlobalStyle`
  ${(props) => {
    const config = getWhitelabelFontConfig(props.theme.whitelabel?.theme?.font_family);
    return config.fontFaceCss;
  }}

  :root {
    --primary-color: ${(props) => props.theme.whitelabel?.theme?.text_primary_color};
    --secondary-color: ${(props) => props.theme.whitelabel?.theme?.text_secondary_color};
    --button-primary-color: ${(props) => props.theme.whitelabel?.theme?.button_primary_color};
    --button-secondary-color: ${(props) => props.theme.whitelabel?.theme?.button_secondary_color};
    --button-primary-text-color: #FFFFFF;
    --tertiary-color: ${(props) => props.theme.whitelabel?.theme?.text_primary_color};
    --light-color: #91949b;
    --light-wl-gray: #696969;
    --warning: #FF5722;
    --danger: #96143C;
    --text-title: ${(props) => props.theme.whitelabel?.theme?.text_primary_color};
    --text-dark: ${(props) => props.theme.whitelabel?.theme?.text_primary_color};
    --bs-gutter-x : 2rem;
    --font-family: ${(props) => getWhitelabelFontConfig(props.theme.whitelabel?.theme?.font_family).cssVarFontFamily};
    --icon-color: ${(props) => props.theme.whitelabel?.theme?.text_secondary_color};
    --header-color: ${(props) => props.theme.whitelabel?.theme?.header_color};
    --button-border-radius: ${(props) =>
      getButtonBorderRadius(props.theme.whitelabel?.theme?.border_radius)};
  }
  ${button}
  ${components}
  ${fonts}
  ${colors}
  ${reset}
  body {
    font-family: var(--font-family);
    color: var(--primary-color);
  }

  .bg-primary {
    background: ${(props) => props.theme.whitelabel?.theme?.text_primary_color} !important;
  }

  .wl-page {
    padding-top: 120px;
  }
  .search-visible .wl-page {
    padding-top: 184px;
  }
  /* Desktop: header colapsa em linha única (~80px), busca não adiciona faixa */
  @media (min-width: 1024px) {
    .wl-page,
    .search-visible .wl-page {
      padding-top: 80px;
    }
  }
  /* Empty state for Favorites page: ensure content fills viewport height
     after accounting for fixed header and title spacing */
  .empty-favorites {
    min-height: calc(100vh - 300px);
    display: flex;
    flex-direction: column;
  }
  .empty-favorites__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 1rem;
  }
  .empty-favorites__title {
    padding-bottom: 1.25rem;
  }
  .empty-favorites__description {
    color: var(--light-color);
  }
  .empty-favorites__button {
    margin-top: auto;
    width: 100%;
  }
  .logo-wl {
    max-width: 110px;
    align-self: center;
  }
  .container-menu {
    position: absolute;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    background-color: white;
    animation: fadeInRight 1.5s ease-in-out;

    @keyframes fadeInRight {
      from {
        opacity: 0;
        transform: translateX(50rem);
      }
      to {
        opacity: 1;
      }
    }
  }
  @keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }
  .spinner-border-xs {
    width: 1.3rem;
    height: 1.3rem;
    border-width: 0.15em;
    margin-top: 3px;
  }

  .preloader {
    background-color: #f7f7f7;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999999;
    -webkit-transition: .6s;
    -o-transition: .6s;
    transition: .6s;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: -webkit-center;
  }

  .preloader .preloader-circle {
      width: 90px;
      height: 90px;
      position: relative;
      border-style: solid;
      border-width: 4px;
      border-top-color: var(--primary-color);
      border-bottom-color: transparent;
      border-left-color: transparent;
      border-right-color: transparent;
      z-index: 10;
      border-radius: 50%;
      -webkit-box-shadow: 0 1px 5px 0 rgba(35, 181, 185, 0.15);
      box-shadow: 0 1px 5px 0 rgba(35, 181, 185, 0.15);
      background-color: #ffffff;
      -webkit-animation: zoom 1000ms infinite;
      animation: zoom 1000ms linear infinite;
      -webkit-transition: .0s;
      -o-transition: .0s;
      transition: 0;
  }

  .line-filter {
    height: 1px;
    background: rgb(240 242 245);
    width: 90%;
    position: relative;
    margin: auto;
  }
  .header-wl{
    top: 0px;
    left: 0px;
    right: 0px;
    width: 100%;
    position: fixed;
    z-index: 999;
    background-color: var(--header-color) !important;
 }
 .disable {
    opacity: 0.5;
    pointer-events: none;
  }
  .disable-div {
    pointer-events: none;
    opacity: 0.4;
  }
  .modal-top-100 {
    top: 100px;
  }

  /* Fix modal height for iPhone and mobile devices */
  .modal-dialog {
    max-height: 100vh;
    max-height: 100dvh; /* Dynamic viewport height - accounts for browser UI on iOS */
  }

  .modal-content {
    max-height: 100vh;
    max-height: 100dvh;
  }

  .modal.show .modal-dialog {
    max-height: 100vh;
    max-height: 100dvh;
  }

  /* Desktop: larguras padronizadas dos modais do fluxo (opt-in via ModalApp desktopSize) */
  @media (min-width: 1024px) {
    .modal-dialog.wl-modal-medium { max-width: 640px; }
    .modal-dialog.wl-modal-narrow { max-width: 480px; }
  }

  /* Ensure modal body is scrollable on small screens */
  @media (max-width: 768px) {
    .modal-dialog {
      margin: 0.5rem;
      max-height: calc(100vh - 1rem);
      max-height: calc(100dvh - 1rem);
    }

    .modal-content {
      max-height: calc(100vh - 1rem);
      max-height: calc(100dvh - 1rem);
      display: flex;
      flex-direction: column;
    }

    .modal-body {
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      flex: 1 1 auto;
      max-height: calc(100vh - 100px);
      max-height: calc(100dvh - 100px);
    }

    /* Specific fix for filter modal */
    .modal-filter-responsive {
      max-height: calc(100vh - 1rem);
      max-height: calc(100dvh - 1rem);
      display: flex;
      flex-direction: column;
    }

    .modal-filter-responsive .modal-body {
      overflow: hidden;
      padding: 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;
    }
  }


  @-webkit-keyframes zoom {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transition: .0s;
        -o-transition: .0s;
        transition: .0s;
   }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
        -webkit-transition: .0s;
        -o-transition: .0s;
        transition: .0s;
   }
  }
  @keyframes zoom {
      0% {
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
          -webkit-transition: .0s;
          -o-transition: .0s;
          transition: .0s;
    }
      100% {
          -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
          -webkit-transition: .0s;
          -o-transition: .0s;
          transition: .0s;
    }
  }


// hoteis e carros  envision

.pt-custom {
  padding-top: 133px;
}

.label-modal {
  color: ${(props) => props.theme.whitelabel?.theme?.text_primary_color};
  font-size: 18px;
  font-weight: bold;
  padding: 20px 0 0;
}

  .modal-address {
    padding: 8px 8px 16px 8px;
  }
  .modal-address .modal-body {
    padding: 16px 20px 8px 20px;
    max-height: calc(100vh - 120px);
    overflow-y: auto;
  }
  .modal-address .modal-header {
    padding: 12px 12px 0 12px;
  }
  .modal-address .btn-close {
    filter: invert(15%);
  }

.box-search {
    display: flex;
    margin: 10px 0 30px;
    flex-direction: column;
    gap: 28px;
}

.divider {
    border-right: 1px solid #474646;
    height: 16px;
    margin-top: 0;
}

.filter-content-cars,
 .filter-content{
    position: relative;
    padding: 15px 0;
}

  .input-custom {
    width: 100%;
    border: 0;
    border-radius: 0;
    border-bottom: 1.5px solid var(--primary-color);
    padding: 0.475rem 0;

    ::placeholder {
      font-size: 14px;
      color: var(--primary-color);
    }

    :focus {
      outline: none;
      box-shadow: none !important;
    }
  }

  .input-custom.is-invalid {
    border-bottom: 1px solid red;
    color: red;
    ::placeholder {
      color: red;
    }
  }

  /* Address form styles */
  .form-address__title {
    color: var(--text-dark);
    font-size: 16px; /* tighter, as per mock */
  }
  .form-address__input {
    border-bottom-color: rgba(5, 9, 34, 0.38);
  }
  .form-address__input::placeholder {
    color: var(--light-wl-gray);
    font-size: 13px;
  }
  .form-address__checkbox input[type="checkbox"] {
    accent-color: var(--primary-color);
  }
  .form-address__label {
    color: var(--text-dark);
    font-size: 12px;
  }

  .address-principal-badge {
    box-sizing: border-box;
    display: flex;
    width: 88.941px;
    padding: var(--spacing-8, 6.588px) var(--spacing-16, 13.176px);
    justify-content: center;
    align-items: center;
    gap: var(--spacing-none, 0);
    border-radius: var(--button-border-radius);
    background: var(--Sky-100, #E0F2FE);
    color: var(--Sky-600, #0284C7);
    font-family: var(--font-family);
    font-size: 11.529px;
    font-style: normal;
    font-weight: 700;
    line-height: 16.471px;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .default-button {
    background-color: transparent;
    background-image: none;
    color: inherit;
    margin: 0;
    padding: 0;
    border-width: 0;
    font-weight: 600 !important;
  }


.input-group-custom {
    z-index: 555;
    margin-right: 0;
    display: flex;
    align-items: self-end;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: rgba(5, 9, 34, 0.87);
    text-align: center;
    white-space: nowrap;
    background-color: none;
    border: none;
    border-bottom:1px solid #333;
    border-radius: 0;
    padding: 0.175rem 0.375rem 0.175rem 0.375rem;
}

.input-group-custom svg {
    width: 19px;
    height:19px;
}

.svg-custom svg {
    height: 20px;
}

.input-group-custom .checkbox-custom {
    padding: 0;
}

.checkbox-custom {
    height: 20px;
    width: 20px;
    background-color: #eee;
}

.form-select-custom {
    border: 0;
    border-radius: 0;
    font-size: 16px;
    box-shadow: none;
    background-color: transparent;
    padding: 0.175rem 0.175rem;
    color: #rgba(5,9,34,0.87);
}

.form-select-custom::option{
    padding: 3px;
}

.form-select-custom:focus {
    box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 0%);
    border-color: #707070;
}

.form-select-custom:disabled {
    background-color: transparent;
}

.form-control {
  border-color: var(--primary-color) !important;
  color: var(--primary-color) !important;

  &:focus {
    border-color: var(--primary-color) !important;
    color: var(--primary-color) !important;
  }

  &:active {
    border-color: var(--primary-color) !important;
    color: var(--primary-color) !important;
  }

  &:hover {
    border-color: var(--primary-color) !important;
    color: var(--primary-color) !important;
  }

}

.form-control-custom {
    border: 0;
    border-radius: 0;
    font-size: 16px;
    box-shadow: none;
    background-color: #FFF;
    padding: 0.175rem 0;
    color: rgba(5, 9, 34, 0.87);
}

.form-control-custom::placeholder {
    color: rgba(5, 9, 34, 0.87);
}

.border-custom {
    border-bottom: 1px solid #707070;
}

.form-control-custom:focus {
    box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 0%);
    border-color: #707070;
}

.form-control-custom:disabled, .form-control-custom[readonly] {
    background-color: #FFF;
}

.disabled-input {
   opacity: 0.6;
}

.label-custom {
    border-bottom: 1px solid #474646;
    font-size: 16px;
    color: rgba(5, 9, 34, 0.87);
    align-items: center;
    display: flex;
    flex-grow: 1;
}

.custom-radio {
  cursor: pointer;
  appearance: none;
  border: 1px solid  rgba(5, 9, 34, 0.38);
  width: 25px;
  height: 25px;
  border-radius: 50%;
  position: relative;
  display:flex;
  align-items: center;
  justify-content: center;

    &:before {
        content: "";
        position: absolute;
        width: 17px;
        height: 17px;
        background: ${(props) => props.theme.whitelabel?.theme?.text_primary_color};
        border-radius: 50%;
        opacity: 0;
    }
    &:checked:before {
        opacity: 1;
    }

    @media(max-width: 800px) {
        width: 18px;
        height: 18px;

        &:before {
            width: 12px;
            height: 12px;
        }
    }
}

.label-head {
  color: ${(props) => props.theme.whitelabel?.theme?.text_primary_color};
  font-weight: bold;
}

.border-checked {
    border: 1px solid ${(props) => props.theme.whitelabel?.theme?.text_primary_color};
    transition: all .3s ease-in-out;
}

.border-focused {
  border: 1px solid ${(props) => props.theme.whitelabel?.theme?.text_primary_color};
  border-radius: 8px;
}
.logo-wl{
  max-width: 120px;
}
.custom-icon-wl {
  color: var(--icon-color) !important;
  stroke: var(--icon-color) !important;
  fill: var(--icon-color) !important;
}

.italic {
  font-style: italic;
}

.not-italic {
  font-style: normal;
}
.custom-icon-wl > svg {
  width: 16px;
  height: 16px;
}

.css-1x51dt5-MuiInputBase-input-MuiInput-input {
  font-size: 16px !important;
  padding: 2px 0 16px !important;
}
.css-o4b71y-MuiAccordionSummary-content{
margin: 24px 0 !important;
}
.color-text-warning{
  color: var(--warning);
}

  /* MUI v5 - Force primary border color for all input variants */
  /* Outlined inputs (TextField variant="outlined", Autocomplete, Select, etc) */
  .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border-color: var(--primary-color) !important;
  }
  .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: var(--primary-color) !important;
  }
  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: var(--primary-color) !important;
  }
  .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
    border-color: var(--primary-color) !important;
  }

  /* Standard inputs (TextField variant="standard") */
  .MuiInputBase-root.MuiInput-root.MuiInput-underline:before {
    border-bottom-color: var(--primary-color) !important;
  }
  .MuiInputBase-root.MuiInput-root.MuiInput-underline:hover:not(.Mui-disabled):before {
    border-bottom-color: var(--primary-color) !important;
  }
  .MuiInputBase-root.MuiInput-root.MuiInput-underline:after {
    border-bottom-color: var(--primary-color) !important;
  }
  .MuiInputBase-root.MuiInput-root.MuiInput-underline.Mui-error:after {
    border-bottom-color: var(--primary-color) !important;
  }

  /* Filled inputs (TextField variant="filled") */
  .MuiFilledInput-root:before {
    border-bottom-color: var(--primary-color) !important;
  }
  .MuiFilledInput-root:hover:not(.Mui-disabled):before {
    border-bottom-color: var(--primary-color) !important;
  }
  .MuiFilledInput-root:after {
    border-bottom-color: var(--primary-color) !important;
  }
  .MuiFilledInput-root.Mui-error:after {
    border-bottom-color: var(--primary-color) !important;
  }
`;
export default GlobalStyles;
